<!--일정변경 버튼-->
<template>
    <button type="button" class="btn-m" @click="showBookingController">일정변경</button>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props:{
        sendId : {
            type: String,
            required: true
        },
        notConvertBookingDate : {
            type: String,
            required: true
        },
    },

    data() {
        return {
        }
    },

    computed: {
		...mapState({
            userData: state => state.userData,
            userNo: state => state.userNo,
            vuexSendId: state => state.vuexSendId,
            visibleBookingLayerPopup: state => state.modalStore.modalsObj.visibleBookingLayerPopup,
        }),	
	},

    methods : {
        // 일정변경 컴포넌트 노출
        showBookingController(){
            this.setVuexData();
            this.$store.commit('modalStore/setVisibleBookingLayerPopup', true);
        },

        setVuexData() {
            this.$store.commit('setVuexSendId', this.sendId);
            this.$store.commit('setTempBookingDate', this.notConvertBookingDate);
        }
    },

}
</script>

<style lang="scss" scoped>
@import '@/assets/css/order.scss';
</style>